
const BoldText:React.FC<{text:string | undefined}> = ({text}) => {
    return(
     <> 
        <div className='text-left' style={{fontSize:'14px', fontWeight:'600', fontFamily:"'Quicksand', sans-serif"}}>{text}</div>
     </>
    )
 }
 export default BoldText